import React, { Fragment, useEffect, useMemo } from 'react'
import { Navigate, useParams } from 'react-router-dom'

import styles from './VerifyAccount.module.css'

import EntryForm, { EntryFormContainer } from 'Layout/EntryForm'
import Heading from 'Design/components/Heading'
import Spinner from 'Design/components/Spinner'

import { useVerifyAccountMutation } from './verify-account.service'

const InProgress = () => {
  return (
    <Fragment>
      <Spinner className={styles.StatusIcon} />
      <p>
        Please wait... <br />
        We are verifying your account
      </p>
    </Fragment>
  )
}

const Failed = () => {
  return (
    <Fragment>
      <Heading className={styles.StatusIcon}>😕</Heading>
      <p>
        Your signup verification token has expired, and we have reissued a new one.
        <br />
        Please check your email.
      </p>
    </Fragment>
  )
}

const Status = ({ status }) => {
  switch (status) {
    case 'inprogress':
      return <InProgress />

    case 'failed':
      return <Failed />

    default:
      return null
  }
}

const VerifyAccount = () => {
  const { token } = useParams()
  const [verifyAccount, verifyAccountResult] = useVerifyAccountMutation()

  useEffect(() => {
    if (!token) {
      return
    }

    verifyAccount(token)
  }, [token, verifyAccount])

  const invitationStatus = useMemo(() => {
    switch (true) {
      case verifyAccountResult.isUninitialized:
      case verifyAccountResult.isLoading:
        return 'inprogress'

      case verifyAccountResult.isError:
        return 'failed'

      default:
        return 'inprogress'
    }
  }, [verifyAccountResult])

  if (verifyAccountResult.isSuccess) {
    return <Navigate to='/login' replace state='accountVerificationSuccess' />
  }

  return (
    <EntryForm>
      <EntryFormContainer className={styles.FormContainer}>
        <Status status={invitationStatus} />
      </EntryFormContainer>
    </EntryForm>
  )
}

export default VerifyAccount
